export var InternalObjectProperty;
(function (InternalObjectProperty) {
    InternalObjectProperty[InternalObjectProperty["Map"] = 0] = "Map";
    InternalObjectProperty[InternalObjectProperty["Call"] = 1] = "Call";
    InternalObjectProperty[InternalObjectProperty["Construct"] = 2] = "Construct";
    InternalObjectProperty[InternalObjectProperty["BlockchainInterface"] = 3] = "BlockchainInterface";
    InternalObjectProperty[InternalObjectProperty["Data0"] = 4] = "Data0";
    InternalObjectProperty[InternalObjectProperty["Data1"] = 5] = "Data1";
})(InternalObjectProperty || (InternalObjectProperty = {}));

//# sourceMappingURL=InternalObjectProperty.js.map
